document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cf-builder]').forEach((builder) => {
    const boxes = Array.from(builder.querySelectorAll('[data-box-choice]'));
    const cuts = Array.from(builder.querySelectorAll('[data-cut]'));
    const purchaseInputs = Array.from(builder.querySelectorAll('input[name="cf_purchase_type"]'));
    const frequencyWrap = builder.querySelector('[data-frequency-wrap]');
    const frequencySelect = builder.querySelector('[data-frequency]');
    const sellingPlanData = builder.querySelector('[data-selling-plans]');
    const usedEl = builder.querySelector('[data-used]');
    const remainingEl = builder.querySelector('[data-remaining]');
    const fillEl = builder.querySelector('[data-fill]');
    const noteEl = builder.querySelector('[data-note]');
    const addBtn = builder.querySelector('[data-add-box]');

    let selectedBox = boxes[0];
    let plans = {};

    try {
      plans = JSON.parse(sellingPlanData.textContent || '{}');
    } catch (e) {
      plans = {};
    }

    function purchaseType() {
      const checked = purchaseInputs.find(input => input.checked);
      return checked ? checked.value : 'subscription';
    }

    function boxPoints() {
      return parseInt(selectedBox.dataset.points || '0', 10);
    }

    function usedPoints() {
      return cuts.reduce((sum, cut) => {
        const qty = parseInt(cut.querySelector('[data-qty]').value || '0', 10);
        const pts = parseInt(cut.dataset.points || '0', 10);
        return sum + (qty * pts);
      }, 0);
    }

    function selectedCutsText() {
      return cuts.map(cut => {
        const qty = parseInt(cut.querySelector('[data-qty]').value || '0', 10);
        if (!qty) return null;
        return `${qty}x ${cut.dataset.title} (${cut.dataset.points} pts each)`;
      }).filter(Boolean).join(', ');
    }

    function resetCuts() {
      cuts.forEach(cut => {
        cut.querySelector('[data-qty]').value = 0;
      });
    }

    function updateFrequency() {
      const type = purchaseType();
      const productId = selectedBox.dataset.productId;
      const boxPlans = plans[productId] || [];

      frequencySelect.innerHTML = '';

      boxPlans.forEach(plan => {
        const option = document.createElement('option');
        option.value = plan.id;
        option.textContent = plan.name;
        frequencySelect.appendChild(option);
      });

      frequencyWrap.style.display = type === 'subscription' ? 'block' : 'none';
    }

    function render() {
      const max = boxPoints();
      const used = usedPoints();
      const remaining = max - used;
      const percent = max > 0 ? Math.min((used / max) * 100, 100) : 0;

      usedEl.textContent = used;
      remainingEl.textContent = Math.max(remaining, 0);
      fillEl.style.width = `${percent}%`;

      if (used === 0) {
        noteEl.textContent = 'Choose cuts to fill your box.';
      } else if (remaining > 0) {
        noteEl.textContent = `${remaining} point${remaining === 1 ? '' : 's'} remaining.`;
      } else if (remaining === 0) {
        noteEl.textContent = 'Perfect. Your box is full.';
      } else {
        noteEl.textContent = `You are over by ${Math.abs(remaining)} points.`;
      }

      addBtn.disabled = used === 0 || remaining !== 0;
      updateFrequency();
    }

    boxes.forEach(box => {
      box.addEventListener('click', () => {
        boxes.forEach(b => b.classList.remove('is-active'));
        box.classList.add('is-active');
        selectedBox = box;
        resetCuts();
        render();
      });
    });

    purchaseInputs.forEach(input => {
      input.addEventListener('change', render);
    });

    cuts.forEach(cut => {
      const minus = cut.querySelector('[data-minus]');
      const plus = cut.querySelector('[data-plus]');
      const qtyInput = cut.querySelector('[data-qty]');

      minus.addEventListener('click', () => {
        const current = parseInt(qtyInput.value || '0', 10);
        qtyInput.value = Math.max(0, current - 1);
        render();
      });

      plus.addEventListener('click', () => {
        const current = parseInt(qtyInput.value || '0', 10);
        const cutPoints = parseInt(cut.dataset.points || '0', 10);
        const max = boxPoints();
        const used = usedPoints();

        if (used + cutPoints <= max) {
          qtyInput.value = current + 1;
        } else {
          noteEl.textContent = `That would exceed your ${max}-point box.`;
        }

        render();
      });
    });

    addBtn.addEventListener('click', async () => {
      const type = purchaseType();
      const variantId = selectedBox.dataset.variantId;
      const selectedPlan = frequencySelect.value;

      const item = {
        id: Number(variantId),
        quantity: 1,
        properties: {
          'Box Type': selectedBox.dataset.title,
          'Purchase Type': type === 'subscription' ? 'Subscription' : 'One-Time',
          'Points Used': `${usedPoints()}/${boxPoints()}`,
          'Selected Cuts': selectedCutsText()
        }
      };

      if (type === 'subscription' && selectedPlan) {
        item.selling_plan = Number(selectedPlan);
      }

      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: [item] })
        });

        if (!res.ok) throw new Error('Could not add item');

        window.location.href = '/cart';
      } catch (error) {
        console.error(error);
        noteEl.textContent = 'Could not add this box. Confirm the selected product has an active subscription plan.';
        addBtn.disabled = false;
        addBtn.textContent = 'Add box to cart';
      }
    });

    if (selectedBox) selectedBox.classList.add('is-active');
    render();
  });
});